class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector(
      '.slider-buttons button[name="previous"]'
    );
    this.nextButton = this.querySelector('.slider-buttons button[name="next"]');
    this.slideThumb = this.querySelectorAll(".product__media-item_thumb a");

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

    for (let i = 0; i < this.slideThumb.length; i++) {
      this.slideThumb[i].addEventListener(
        "click",
        this.onSlideThumbClick.bind(this)
      );
    }
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
       // event.currentTarget.name === "next"
       //  ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
       //  : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    const slideScrollPosition =
    event.currentTarget.name === "next"
        ? (this.currentPage) * this.sliderItems[0].clientWidth
        : (this.currentPage - 2 ) * this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  onSlideThumbClick(event) {
    event.preventDefault();
    const slideThumbIndex = event.currentTarget.getAttribute("imageindex");
    const slideScrollPosition =
      this.sliderItems[0].clientWidth * (slideThumbIndex - 1);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);
